import { render, staticRenderFns } from "./StepTemplateChoice.vue?vue&type=template&id=20e152cf&"
import script from "./StepTemplateChoice.vue?vue&type=script&lang=js&"
export * from "./StepTemplateChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports